import {useMutation} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';

import {useDeletedDocumentsQueryCache} from './use-deleted-documents-query';
import {useDocumentQueryCache} from './use-document-query';

function deleteFromTrashBinRequest() {
    return apiClient.callApi({
        path: 'editor-documents-service/api/documents/trash-bin',
        method: 'DELETE'
    });
}

/** Hook to delete all documents from trash bin */
export function useDeleteFromTrashBinMutation() {
    const deletedQueryCache = useDeletedDocumentsQueryCache();
    const documentQueryCache = useDocumentQueryCache();

    return useMutation({
        mutationFn: deleteFromTrashBinRequest,
        onSuccess: () => {
            deletedQueryCache.invalidate();
            documentQueryCache.clearCache();
        }
    });
}
